import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { createRoot } from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

const onRedirectCallback = (appState) => {
  console.log('onRedirectCallback', appState);
  window.location.assign(appState?.returnTo || window.location.pathname);
};

root.render(
  <StrictMode>
    <Auth0Provider
      domain={window.env.REACT_APP_AUTH0_LOGIN_URL}
      clientId={window.env.REACT_APP_AUTH0_CLIENTID}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/note`
      }}
      onRedirectCallback={onRedirectCallback}
      >
      <ColorModeScript />
      <App />
    </Auth0Provider>
  </StrictMode>
);

